<template>
    <div class="energy-data-query-manage-box">
        <div class="energy-data-query-left">
            <el-container>
                <el-header style="height: auto; font-size: 0.9375rem; font-weight: 600; padding-bottom: 0.5rem">用户列表</el-header>
                <div class="left-item">
                    <div >
                        <el-form>
                            <el-row style="height: 2rem">
                                <el-col align="center">
                                    <el-input v-model="filterText" size="small" style="width: 85%">
                                        <template slot="prepend" style="width:50%;">用户名称/编号</template>
                                    </el-input>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 1rem;height: 2rem">
                                <el-col align="center">
                                    <el-radio-group v-model="meterType" size="mini" >
                                        <el-radio-button label="2">电表</el-radio-button>
                                        <el-radio-button label="1">水表</el-radio-button>
                                    </el-radio-group>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div style="padding-top: 0.5rem"></div>
                    <div class="div-hr"></div>
                    <div class="tree">
                        <flex>
                            <el-main ref="elMain" style="height: calc(100vh - 17.5rem)">
                                <el-tree
                                        class="filter-tree"
                                        :data="energyUnitTree"
                                        node-key="id"
                                        :props="defaultProps"
                                        :default-expanded-keys="expandedKey"
                                        :filter-node-method="filterNode"
                                        :highlight-current="true"
                                        @node-click="click"
                                        :expand-on-click-node="false"
                                        ref="runMonitorTree"
                                        style="background-color: #fafafa; min-width: 100%;display:inline-block;"
                                >
                                </el-tree>
                            </el-main>
                        </flex>
                    </div>
                </div>
            </el-container>
        </div>
        <div class="energy-data-query-center" v-bind:style="{width}">
            <el-container>
                <el-header style="height: auto; font-size: 0.9375rem; font-weight: 600; padding-bottom: 0.5rem">运行监测</el-header>
                <div class="center-item">
                    <div class="legend-statistics">
                        <el-form :inline="true" :model="statistics" size="mini">
                            <el-form-item align="center" style="width: 10rem">
                                <div>
                                    <el-button @click="switchStatistisType('all')" :type="statisticsAll">
                                        <div>
                                            <svg-icon icon-class="icon-all" style="width: 1rem; height: 1rem"></svg-icon><span style="font-size: 1rem">&nbsp;全部</span>
                                        </div>
                                        <div style="font-size: 1rem; padding-top: 0.5rem">
                                           {{statistics.all}}
                                        </div>
                                    </el-button>
                                </div>
                            </el-form-item>
                            <el-form-item align="center" style="width: 10rem">
                                <el-button @click="switchStatistisType('normal')" :type="statisticsNormal">
                                    <div>
                                        <svg-icon icon-class="icon-normal" style="width: 1rem; height: 1rem"></svg-icon><span style="font-size: 1rem">&nbsp;正常</span>
                                    </div>
                                    <div style="font-size: 1rem; padding-top: 0.5rem">
                                        {{statistics.normal}}
                                    </div>
                                </el-button>
                            </el-form-item>
                            <el-form-item align="center" style="width: 10rem">
                                <el-button @click="switchStatistisType('lacking')" :type="statisticsLacking">
                                    <div>
                                        <svg-icon icon-class="icon-lacking" style="width: 1rem; height: 1rem"></svg-icon><span style="font-size: 1rem">&nbsp;余额不足</span>
                                    </div>
                                    <div style="font-size: 1rem; padding-top: 0.5rem">
                                        {{statistics.lacking}}
                                    </div>
                                </el-button>
                            </el-form-item>
                            <el-form-item align="center" style="width: 10rem">
                                <el-button @click="switchStatistisType('openning')" :type="statisticsOpenning">
                                    <div>
                                        <svg-icon icon-class="icon-openning" style="width: 1rem; height: 1rem"></svg-icon><span style="font-size: 1rem">&nbsp;分闸/关阀</span>
                                    </div>
                                    <div style="font-size: 1rem; padding-top: 0.5rem">
                                        {{statistics.openning}}
                                    </div>
                                </el-button>
                            </el-form-item>
                            <el-form-item align="center" style="width: 10rem">
                                <el-button @click="switchStatistisType('offline')" :type="statisticsOffline">
                                    <div>
                                        <svg-icon icon-class="icon-offline" style="width: 1rem; height: 1rem"></svg-icon><span style="font-size: 1rem">&nbsp;通信中断</span>
                                    </div>
                                    <div style="font-size: 1rem; padding-top: 0.5rem">
                                        {{statistics.offline}}
                                    </div>
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="div-hr"></div>
                    <div class="" style="">
                        <div style="height: calc(100vh - 19.6rem);padding-top: 1rem">

                            <el-form :inline="true" :model="statistics" size="mini">
                                <el-form-item align="center" style="width: 8rem" v-for="(meter,index) in curretMeters" :key="index">
                                    <el-button :id="meter.meterId" class="meterButton" type="text" :style="buttonStyle" @click="getInfo(meter.meterId,meter.customerUserId,index)" plain>
                                        <div>
                                            <svg-icon :icon-class="
                                        meter.warningTypeId === 'af4521c7-6ffe-4d98-b3bb-eef78e85a879' ? '中断' :
                                        meter.warningTypeId === '08228ea7-1575-4b95-9a0d-592edfff4f19' ? '余额不足' :
                                        meter.warningTypeId === 'c9cba4ea-ed9d-424C-8a07-e7769eb04bd7' ? '分闸' : '正常'"
                                                      style="width: 2rem; height: 2rem"></svg-icon>
                                        </div>
                                        <div style="color: black;overflow: hidden;padding-top: 1rem">
                                            {{ meter.meterName }}
                                        </div>
                                    </el-button>
                                </el-form-item>
                            </el-form>

                        </div>
                        <div class="page-box" style="height: 10%;">
                            <el-pagination
                                @current-change="customerUserMeterCurrentChange"
                                :current-page="customerUserMeterPage.current"
                                :page-size="customerUserMeterPageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="pageTotal">
                            </el-pagination>
                        </div><!--分页-->
                    </div>
                </div>
            </el-container>
        </div>
        <div class="energy-data-query-right" v-if="show === 1">
            <el-container>
                <el-header style="height: auto; font-size: 0.9375rem; font-weight: 600; padding-bottom: 0.5rem">仪表信息</el-header>
                <div class="right-item" style="height: calc(100vh - 11.25rem)">
                    <flex>
                        <div style="height: 35%">
                            <div style="padding-left: 2rem">
                                <div style="width: 10rem"  align="center">
                                    <div>
                                        <svg-icon :icon-class="nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '水表' : '电表'" style="width: 5rem; height: 4rem; padding-left: 2.5rem; padding-top: 2.5rem"></svg-icon>
                                    </div>
                                    <div style="font-size: 1rem; font-weight: bold; padding-left: 2.5rem; padding-top: 0.5rem; word-wrap: break-word;">{{ meterInfo.name }}</div>
                                </div>
                            </div>
                            <div style="padding-left: 2.5rem; height: auto">
                                <div>
                                    <div style="width: 2rem; float: left">
                                        <svg-icon icon-class="累计用水量" style="width: 1.5rem; height: 1.5rem;"></svg-icon>
                                    </div>
                                    <div style="font-size: 0.8rem; padding-left: 1rem; ">
                                        累计用{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '水' : '电'}}量&nbsp;&nbsp;
                                        <span style="font-size: 1rem; font-weight: bold;">
                                        {{ formatNumber(meterInfo.accountBaseData) }}
                                    </span>
                                        &nbsp;&nbsp;{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? 'm³' : 'kWh'}}
                                    </div>
                                </div>
                                <div style="padding-top: 0.5rem">
                                    <div style="width: 2rem; float: left">
                                        <svg-icon icon-class="累计用水量" style="width: 1.5rem; height: 1.5rem;"></svg-icon>
                                    </div>
                                    <div style="font-size: 0.8rem; padding-left: 1rem; ">
                                        当前表底值&nbsp;&nbsp;
                                        <span style="font-size: 1rem; font-weight: bold;">
                                        {{ formatNumber(meterInfo.accountTotalAmount) }}
                                    </span>
                                        &nbsp;&nbsp;{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? 'm³' : 'kWh'}}
                                    </div>
                                </div>
                                <div style="padding-top: 0.5rem">
                                    <div style="width: 2rem; float: left">
                                        <svg-icon icon-class="余额" style="width: 1.5rem; height: 1.5rem;"></svg-icon>
                                    </div>
                                    <div style="font-size: 0.8rem; padding-left: 1rem; ">
                                        &nbsp;&nbsp;当前余额&nbsp;&nbsp;&nbsp;&nbsp;
                                        <span style="font-size: 1rem; font-weight: bold;">
                                            {{ formatNumber(meterInfo.balance) }}
                                        </span>
                                        &nbsp;&nbsp;元
                                    </div>
                                </div>
                                <div style="padding-top: 0.5rem">
                                    <div style="width: 2rem; float: left">
                                        <svg-icon icon-class="时间" style="width: 1.5rem; height: 1.5rem;"></svg-icon>
                                    </div>
                                    <div style="font-size: 0.8rem; padding-left: 1rem; padding-top: 0.5vh">
                                        &nbsp;&nbsp;抄表时间&nbsp;&nbsp;&nbsp;&nbsp;
                                        <span style="font-size: 0.8rem; font-weight: bold;">
                                            {{ meterInfo.meterReadingTime }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="div-hr"></div>
                        <div style="height: 65%">
                            <div style="height:auto">
                                <div style="width: 12rem; padding-left: 2.5rem">
                                    <div style="padding-top: 0.5rem">
                                        业主用户名称：
                                        <span class="info">
                                            {{ tenantInfo.realName }}
                                        </span>
                                    </div>
                                    <div style="padding-top: 0.5rem">
                                        业主用户编码：
                                        <span class="info">
                                            {{ tenantInfo.name }}
                                        </span>
                                    </div>
                                    <div style="padding-top: 0.5rem">
                                        业主用户地址：
                                        <span class="info">
                                            {{ tenantInfo.address }}
                                        </span>
                                    </div>
                                    <div style="padding-top: 0.5rem">
                                        联系人：
                                        <span class="info">
                                            {{ tenantInfo.contactPerson }}
                                        </span>
                                    </div>
                                    <div style="padding-top: 0.5rem">
                                        手机号码：
                                        <span class="info">
                                            {{ tenantInfo.mobile }}
                                        </span>
                                    </div>
                                    <div style="padding-top: 0.5rem">
                                        仪表名称：
                                        <span class="info">
                                            {{ meterInfo.name }}
                                        </span>
                                    </div>
                                    <div style="padding-top: 0.5rem">
                                        仪表编码：
                                        <span class="info">
                                            {{ meterInfo.code }}
                                        </span>
                                    </div>
                                    <div style="padding-top: 0.5rem">
                                        表号：
                                        <span class="info">
                                            {{ meterInfo.meterNum }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div style="height: auto">
                                <div v-if="targetId === '' ? false : true">
                                    <div style="padding-left: 3rem; padding-top: 1rem" v-show="meterInfo.meterTypeId !== '2d49e0b5-f37d-11e8-9c8f-0235d2b38928' && meterInfo.meterTypeId !== '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b'">
                                        <!--<el-radio-group v-model="splitSwitch" size="mini" >
                                            <el-radio-button label="1">分闸</el-radio-button>
                                            <el-radio-button label="0">合闸</el-radio-button>
                                        </el-radio-group>-->
                                        <el-button-group>
                                            <el-tooltip placement="top" effect="light">
                                                <div slot="content">保{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '水' : '电'}}模式下，仪表不会因欠费而{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '关阀' : '跳闸'}}。</div>
                                                <el-button @click="switchPower(0)" :type="meterInfo.meterMoney === null ? '' : meterInfo.meterMoney.isCutoutOfArrear === null ? '' : meterInfo.meterMoney.isCutoutOfArrear === 1 ? '' : 'primary'" size="mini" style="width: 5vw">{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '保水模式' : '保电模式'}}</el-button>
                                            </el-tooltip>
                                            <el-tooltip placement="top" effect="light">
                                                <div slot="content">费控模式下，仪表会因欠费而{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '关阀' : '跳闸'}}。</div>
                                                <el-button @click="switchPower(1)" :type="meterInfo.meterMoney === null ? '' : meterInfo.meterMoney.isCutoutOfArrear === null ? '' : meterInfo.meterMoney.isCutoutOfArrear === 0 ? '' : 'primary'" size="mini" style="width: 5vw">{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '解除保水' : '解除保电'}}</el-button>
                                            </el-tooltip>
                                        </el-button-group>
                                        <el-button-group style="padding-top: 1rem">
                                            <el-tooltip placement="left" effect="light">
                                                <div slot="content">对仪表进行{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '开阀' : '合闸'}}操作，<br/>{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '开阀' : '合闸'}}操作伴随保{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '水' : '电'}}动作。</div>
                                                <el-button @click="changeSplitSwitch(0)" :type="meterInfo.splitSwitch === null ? '' : meterInfo.splitSwitch === 0 ? 'primary' : ''" size="mini" style="width: 5vw">{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '开阀' : '合闸'}}</el-button>
                                            </el-tooltip>
                                            <el-tooltip placement="right" effect="light">
                                                <div slot="content">对仪表进行{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '关阀' : '分闸'}}操作，<br/>要求仪表处于非保{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '水' : '电'}}模式下。</div>
                                                <el-button @click="changeSplitSwitch(1)" :type="meterInfo.splitSwitch === null ? '' : meterInfo.splitSwitch === 1 ? 'primary' : ''" size="mini" style="width: 5vw">{{nonElectricMeterIds.indexOf(meterInfo.meterTypeId) > -1 ? '关阀' : '分闸'}}</el-button>
                                            </el-tooltip>
                                        </el-button-group>
                                    </div>
                                    <div style="padding-left: 3rem; padding-top: 1rem">
                                        <el-button size="mini" @click="toRecharge(meterInfo.id,tenantInfo.id)" style="width: 10vw">充值</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </flex>
                </div>
            </el-container>
        </div>

        <el-dialog :visible.sync="switchPowerDialogVisible" width="30rem" top="30vh" size="small" v-if="targetId === '' ? false : true">
            <template slot="title">
                {{switchPowerDialogVisibleName}}
            </template>
            <div style="display: flex; flex-direction: column; justify-content: center">
                <div style="height:auto">
                    <div style="padding-left: 4rem">
                        <div style="padding-top: 0.5rem">
                            业主用户名称：
                            <span class="info">
                                    {{ tenantInfo.realName }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            业主用户编码：
                            <span class="info">
                                    {{ tenantInfo.name }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            业主用户地址：
                            <span class="info">
                                    {{ tenantInfo.address }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            联系人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ tenantInfo.contactPerson }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            手机号码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ tenantInfo.mobile }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            仪表名称&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ meterInfo.name }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            仪表编码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ meterInfo.code }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            表号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ meterInfo.meterNum }}
                                </span>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="switchPowerDialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="controlAvailable" size="small">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="controlSwitchDialogVisible" width="30rem" top="30vh" size="small" v-if="">
            <template slot="title">
                {{controlSwitchDialogVisibleName}}
            </template>
            <div style="display: flex; flex-direction: column; justify-content: center">
                <div style="height:auto">
                    <div style="padding-left: 4rem">
                        <div style="padding-top: 0.5rem">
                            业主用户名称：
                            <span class="info">
                                    {{ tenantInfo.realName }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            业主用户编码：
                            <span class="info">
                                    {{ tenantInfo.name }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            业主用户地址：
                            <span class="info">
                                    {{ tenantInfo.address }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            联系人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ tenantInfo.contactPerson }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            手机号码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ tenantInfo.mobile }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            仪表名称&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ meterInfo.name }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            仪表编码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ meterInfo.code }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            表号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ meterInfo.meterNum }}
                                </span>
                        </div>
                        <div style="padding-top: 0.5rem">
                            余额&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：
                            <span class="info">
                                    {{ formatNumber(meterInfo.balance) }}
                                </span>
                            元
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="controlSwitchDialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="controlSwitch" size="small">确认</el-button>
            </span>
        </el-dialog>

    </div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { tree, expandedFirstTop } from '@/utils/energyUtilTree'
  import { getCustomerAndMeter,controlAvailable, controlSwitch, queryMeterStatus } from "@/api/runMonitor"
  import { refreshTime } from "@/config/config"
  import { uuidWithoutLine } from "@/utils/uuid"
  import { WS } from '@/utils/ws'
  import Flex from "@/components/Flex";
  import { returnFloat } from "@/utils/numberUtil"
  import { non_electric_meter_ids } from "@/config/config";

  export default {
    name: 'meterManage',
    components: {Flex},
    data() {
      return {
        filterText: '',
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        energyUnitTree: [], /* 能耗单元树*/
        meterType: 2,
        expandedKey: [], // 展开的节点id
        checkedMeterIds: new Map(),
        activeMeterIds: new Map(),
        rechargeAmount: {value:0},
        customerUserMeter: [],
        customerUserMeterPage: {
          current: 1
        }, /* 分页对象*/
        customerUserMeterCurrentPage: 1,
        customerUserMeterPageSize: 54,
        statistics: {
          all: 0,
          lacking: 0,
          normal: 0,
          offline: 0,
          openning: 0
        },
        curretMeters: [],//分页用
        data: {},//点击节点缓存
        node: {},//点击节点缓存
        meterIds: [],
        meterInfo: {},
        tenantInfo: {},
        targetId: '',
        switchPowerDialogVisible: false,
        controlSwitchDialogVisible: false,
        switchPowerDialogVisibleName: '',
        controlSwitchDialogVisibleName: '',
        availableElectric: null,
        controlSwitchFlag: null,
        show: 0,
        nonElectricMeterIds: [],
        width: '100%',
        amount: 54,
        positionArr: new Map,
        buttonStyle: 'height: 5rem;width: 10rem',
        statisticsType: 'all',//统计类型 默认全部
        statisticsMeters: [],
        statisticsAll: 'text',
        statisticsNormal: 'text',
        statisticsLacking: 'text',
        statisticsOpenning: 'text',
        statisticsOffline: 'text',
        controlAvailableSubscribe: {},//保电/解除保电订阅对象
        controlSwitchSubscribe: {},//分合闸订阅对象
        meterStatusSubscribe: {},
        pageTotal: 0,
        meterInfos: {
          all: [],
          normal: [],
          openning: [],
          lacking: [],
          offline: []
        },
        timeOutObject: null,
      }
    },
    computed: {
      ...mapGetters([
        'customerId',
        'userId'
      ])
    },
    watch: {
      filterText(val) {
        this.$refs.runMonitorTree.filter(val)
      },
      meterType() { // 监听能源类型变化
        this.getEnergyUnitTree()
      },
    },
    mounted() {
      this.nonElectricMeterIds = non_electric_meter_ids
      this.expandedKey = []
      this.getEnergyUnitTree()

      //WebSocket

      this.controlAvailableSubscribe = new WS();
      this.controlAvailableSubscribe.connect(res => {
        this.controlAvailableSubscribe.subscribe("/topic/controlAvailable/"+this.userId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
          let result = JSON.parse(val.body)
          let meterName = result.meter.name
          var title = ''
          if(result.availableElectric === true){
            title = '保电/保水'
          }else{
            title = '解除保电/保水'
          }
          if(result.code === 200){
            this.$notify({
              title: title,
              message: '仪表：'+meterName+' ' +title+ '成功',
              duration: 9000,
              offset: 100,
              type: 'success'
            });
            if(this.targetId !== ''){
              if(this.targetId === result.meter.id){
                this.meterInfo.meterMoney.isCutoutOfArrear = result.meter.meterMoney.isCutoutOfArrear
              }
            }
          }else{
            this.$notify({
              title: title,
              message: '仪表：'+meterName+' ' +title+ '失败',
              duration: 9000,
              offset: 100,
              type: 'error'
            });
          }
        })
      }, err => {

      })

      this.controlSwitchSubscribe = new WS();
      this.controlSwitchSubscribe.connect(res => {
        this.controlSwitchSubscribe.subscribe("/topic/controlSwitch/"+this.userId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
          let result = JSON.parse(val.body)
          let meterName = result.meter.name
          var title = result.information
          if(result.code === 200){
            this.$notify({
              title: title,
              message: '仪表：'+meterName+' ' +title+ '成功',
              duration: 9000,
              offset: 100,
              type: 'success'
            });
            if(this.targetId !== ''){
              if(this.targetId === result.meter.id){
                this.meterInfo.meterMoney.isCutoutOfArrear = result.meter.meterMoney.isCutoutOfArrear
                this.meterInfo.splitSwitch = result.meter.splitSwitch
              }
            }
          }else{
            this.$notify({
              title: title,
              message: '仪表：'+meterName+' ' +title+ '失败',
              duration: 9000,
              offset: 100,
              type: 'error'
            });
          }
        })
      }, err => {

      })

      this.meterStatusSubscribe = new WS();
      this.meterStatusSubscribe.connect(res => {
        this.meterStatusSubscribe.subscribe("/topic/meterStatus/"+this.userId, (val) => {//发生报警触发查询
          let result = JSON.parse(val.body)
          this.getMeterStatus()

          this.timeOutObject = window.setTimeout(()=>{this.getMeterStatus()},10*1000);
        })
      }, err => {

      })
    },
    destroyed(){
      if (this.controlAvailableSubscribe && this.controlAvailableSubscribe.connected) {
        this.controlAvailableSubscribe.disconnect()
      }
      // 清除订阅记录
      if (this.controlSwitchSubscribe && this.controlSwitchSubscribe.connected) {
        this.controlSwitchSubscribe.disconnect()
      }
      if (this.meterStatusSubscribe && this.meterStatusSubscribe.connected) {
        this.meterStatusSubscribe.disconnect()
      }
    },
    methods: {
      getMeterStatus: function(){
        console.log("仪表状态查询")
        queryMeterStatus(this.meterIds).then(res => {
          if (res.code === 200) {
            this.statistics.all = res.infoJson.all.length
            this.statistics.normal = res.infoJson.normal.length
            this.statistics.openning = res.infoJson.openning.length
            this.statistics.lacking = res.infoJson.lacking.length
            this.statistics.offline = res.infoJson.offline.length
            this.meterInfos.all = res.infoJson.all
            this.meterInfos.normal = res.infoJson.normal
            this.meterInfos.openning = res.infoJson.openning
            this.meterInfos.lacking = res.infoJson.lacking
            this.meterInfos.offline = res.infoJson.offline
            this.pageTotal = this.meterInfos[this.statisticsType].length
            let start = this.amount*(this.customerUserMeterPage.current-1)
            let end = this.amount*(this.customerUserMeterPage.current)
            const meterArr = this.meterInfos[this.statisticsType]
            this.curretMeters = meterArr.slice(start,end)
            for(var i = 0; i < this.meterInfos[this.statisticsType].length; i ++){
              this.positionArr.set(this.meterInfos[this.statisticsType][i].meterId,i)
            }
          }else{
            Message({
              message: '仪表状态查询失败',
              type: 'warning',
              duration: 5 * 1000
            })
          }
        })
      },
      switchStatistisType: function(statistisType){
        this.statisticsType = statistisType
        //重置页数信息
        this.customerUserMeterPage.current = 1
        this.customerUserMeterCurrentPage = 1
        this.pageTotal = this.meterInfos[statistisType].length
        let start = this.amount*(this.customerUserMeterCurrentPage-1)
        let end = this.amount*(this.customerUserMeterCurrentPage)
        const meterArr = this.meterInfos[statistisType]
        this.curretMeters = meterArr.slice(start,end)
        var y = document.getElementsByClassName('meterButton')
        for(var i = 0; i < y.length; i ++){
          y[i].style.borderColor = ''
        }
        this.statisticsAll = 'text'
        this.statisticsLacking = 'text'
        this.statisticsNormal = 'text'
        this.statisticsOffline = 'text'
        this.statisticsOpenning = 'text'
        if(statistisType === 'all'){
          this.statisticsAll = ''
        }else if(statistisType === 'normal'){
          this.statisticsNormal = ''
        }else if(statistisType === 'lacking'){
          this.statisticsLacking = ''
        }else if(statistisType === 'offline'){
          this.statisticsOffline = ''
        }else if(statistisType === 'openning'){
          this.statisticsOpenning = ''
        }
        for(var i = 0; i < this.meterInfos[statistisType].length; i ++){
          this.positionArr.set(this.meterInfos[statistisType][i].meterId,i)
        }
      },
      changeSplitSwitch: function(value){
          if(this.meterInfo !== null){
              if(this.meterInfo.splitSwitch === value){
                  Message({
                      message: '仪表[' + this.meterInfo.name + ']已处于' + (value === 0 ? '合闸' : '分闸' + '模式！'),
                      type: 'warning',
                      duration: 5 * 1000
                  })
                  return
              }
              const isCutoutOfArrear = this.meterInfo.meterMoney.isCutoutOfArrear
              if(value === 1){//分闸
                  if(isCutoutOfArrear === 0){
                      Message({
                          message: '仪表['+this.meterInfo.name+']处于保电模式，请解除保电后再分闸！',
                          type: 'warning',
                          duration: 5 * 1000
                      })
                      return
                  }
                  this.controlSwitchFlag = false
                  this.controlSwitchDialogVisibleName = '分闸'
                  this.controlSwitchDialogVisible = true
              }else{
                  this.controlSwitchFlag = true
                  this.controlSwitchDialogVisibleName = '合闸'
                  this.controlSwitchDialogVisible = true
              }
          }else{
              Message({
                  message: '请选择仪表！',
                  type: 'warning',
                  duration: 5 * 1000
              })
              return
          }

      },
      controlSwitch: function(){
            var uuid = uuidWithoutLine();
            var meter = this.meterInfo
            var customreUserId = this.userId
            var controlSwitchFlag = this.controlSwitchFlag
            var condition = {uuid: uuid, customerUserId: customreUserId, meter: meter, switchStatus: controlSwitchFlag}
            controlSwitch(condition).then(result => {
                if(result.code === 200){
                    Message({
                        message: result.message,
                        type: 'success',
                        duration: 5 * 1000
                    })
                }else{
                    Message({
                        message: result.message,
                        type: 'warning',
                        duration: 5 * 1000
                    })
                }
                this.controlSwitchDialogVisible = false
            })
        },
      formatNumber: function(value){
        return returnFloat(value)
      },
      switchPower: function(isCutoutOfArrear){
        this.availableElectric = null
        this.switchPowerDialogVisibleName = ''
        if(this.meterInfo.meterMoney !== null){
          if(isCutoutOfArrear === this.meterInfo.meterMoney.isCutoutOfArrear && isCutoutOfArrear === 1){
            Message({
              message: '仪表['+this.meterInfo.name+']处于解除保电模式！',
              type: 'warning',
              duration: 5 * 1000
            })
            return
          }
          if(isCutoutOfArrear === this.meterInfo.meterMoney.isCutoutOfArrear && isCutoutOfArrear === 0){
            Message({
              message: '仪表['+this.meterInfo.name+']处于保电模式！',
              type: 'warning',
              duration: 5 * 1000
            })
            return
          }
        }
        if(isCutoutOfArrear === 0){
          this.availableElectric = true
          this.switchPowerDialogVisibleName = '保电'
        }else{
          this.availableElectric = false
          this.switchPowerDialogVisibleName = '解除保电'
        }
        this.switchPowerDialogVisible = true
      },
      controlAvailable: function(){
        var uuid = uuidWithoutLine();
        var meter = this.meterInfo
        var customreUserId = this.userId
        var availableElectric = this.availableElectric
        var condition = {uuid: uuid, customerUserId: customreUserId, meter: meter, availableElectric: availableElectric}
        controlAvailable(condition).then(result => {
          if(result.code === 200){
            Message({
              message: result.message,
              type: 'success',
              duration: 5 * 1000
            })
            this.switchPowerDialogVisible = false
          }else{
            Message({
              message: result.message,
              type: 'warning',
              duration: 5 * 1000
            })
            this.switchPowerDialogVisible = false
          }
        })
      },
      toRecharge: function(meterId,customerUserId){
        if(typeof meterId === 'undefined' && typeof customerUserId === 'undefined'){
          Message({
            message: '请选择仪表',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        this.$router.push({ //跳转自助充值页面
          path: '/recharge/quickRecharge',
          query: {
            meterId: meterId,
            customerUserId: customerUserId,
          }
        })
      },
      getInfo(meterId,customerUserId,index){
        this.amount = 42
        this.customerUserMeterPageSize = 42
        //计算当前仪表所在的页数
        var position = this.positionArr.get(meterId)
        var page = parseInt(position/42) + 1
        this.customerUserMeterCurrentPage = page
        //this.customerUserMeterPage.current = page
        //切换到该页
        var start = this.amount*(this.customerUserMeterCurrentPage-1)
        var end = this.amount*(this.customerUserMeterCurrentPage)
        const meterArr = this.meterInfos[this.statisticsType]
        this.curretMeters = meterArr.slice(start,end)

        var y = document.getElementsByClassName('meterButton')
        for(var i = 0; i < y.length; i ++){
          y[i].style.borderColor = ''
        }
        var x = document.getElementById(meterId)
        x.style.borderColor = '#909399'
        this.buttonStyle = 'height: 5rem;width: 8rem'

        getCustomerAndMeter(meterId).then(result => {
          if(result.code === 200){
            this.show = 1
            this.width = 'calc(68% - 20px)'
            this.tenantInfo = result.infoJson.customerUser
            this.meterInfo = result.infoJson.meter
            this.targetId = meterId
            this.availableElectric = null
            this.controlSwitchFlag = null
          }
        })
      },
      getEnergyUnitTree() {
        const customerId = this.customerId
        //const approachIds = [approachId]
        this.curretMeters = []
          //重置统计信息
          this.statistics = {
              offline: 0,
              lacking: 0,
              openning: 0,
              normal: 0,
              all: 0
          }
        tree(customerId, null, null, this.meterType,1).then(response => {
          if (response !== null || response !== undefined) {
            this.energyUnitTree = response[0].children
            //获取第一个含有仪表能耗单元的节点id集合
            const keys = expandedFirstTop(this.energyUnitTree)
            if(typeof keys !== 'undefined' && keys !== null){
              if(keys.length>0){
                this.expandedKey.push(keys[0].customerId)
                this.$nextTick(() => {
                  this.$refs.runMonitorTree.setCurrentKey(keys[0].customerId);
                })
              }
              this.meterIds = keys[1].meterId
              if(this.timeOutObject !== null){
                window.clearTimeout(this.timeOutObject)
                this.timeOutObject = null
              }
              this.getMeterStatus()
            }
          }
        }).catch(error => {
          this.energyUnitTree = []
          this.$message({
            type: 'error',
            message: '能耗单元树查询失败'
          })
          console.log(error)
        })

      },
      filterNode(value, data) { //data.id + ''转字符串,number类型报错
        let flag=false;
        if (!value){
          flag=true;
        }else{
          if(data.type==1){ // 1 是用户
            if(data.label!==null&&data.label.indexOf(value) !== -1){
              flag=true;
            }else if(data.code!==null&&data.code.indexOf(value) !== -1){
              flag=true;
            }else{
              flag=false
            }
          }
          if(data.type==2){ // 2 是仪表
            if(data.father.name!==null&&data.father.name.indexOf(value) !== -1){
              flag=true;
            }else if(data.father.code!==null&&data.father.code.indexOf(value) !== -1){
              flag=true;
            }else{
              flag=false
            }
          }
        }
        return flag;
      },
      click(data, node) { // 节点点击事件
        this.meterIds = []
        this.activeMeterIds.clear()
        this.curretMeters = []
        //重置统计信息
        this.statistics = {
          offline: 0,
          lacking: 0,
          openning: 0,
          normal: 0,
          all: 0
        }
        //重置页数信息
        this.customerUserMeterPage.current = 1
        //重置统计类型
        this.statisticsType = 'all'
        this.statisticsAll = ''
        this.statisticsLacking = 'text'
        this.statisticsNormal = 'text'
        this.statisticsOffline = 'text'
        this.statisticsOpenning = 'text'
        this.fetchMeterId(data)
        //取出所有仪表id
        for (var key of this.activeMeterIds) {
          this.meterIds.push(key[0]);
        }
        if(this.timeOutObject !== null){
          window.clearTimeout(this.timeOutObject)
          this.timeOutObject = null
        }
        this.getMeterStatus()
      },
      fetchMeterId(node){
        if(typeof node.type !== 'undefined' && node.type !== null && node.type === 2){
          this.activeMeterIds.set(node.typeId,node.typeId)
        }else{
          if(typeof node.children !== 'undefined' && node.children !== null){
            for(var i = 0; i < node.children.length; i ++){
              this.fetchMeterId(node.children[i])
            }
          }
        }
      },
      customerUserMeterCurrentChange: function(customerUserMeterCurrentPage) {
        this.customerUserMeterPage.current = customerUserMeterCurrentPage
        let start = this.amount*(customerUserMeterCurrentPage-1)
        let end = this.amount*(customerUserMeterCurrentPage)
        const meterArr = this.meterInfos[this.statisticsType]
        this.curretMeters = meterArr.slice(start,end)
      },
    }
  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .energy-data-query-manage-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        font-size: 10px;


        .demo-table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 20%;
        }
        .energy-data-query-left {
            width: 19%;
            .left-item {
                align-items: center;
                padding-top: 0.5rem;
                .el-form-item {
                }
                .div-hr {
                    height: 1px;
                    background-color: #dedede;
                }
                background-color: white;
            }
            .tree {
                padding-bottom: 5px;

            }

        }
        .energy-data-query-center {
            padding-left: 2rem;
            .center-item{
                background-color: white;
                .legend-statistics{
                    padding-top: 10px;
                }
                .div-hr {
                    height: 1px;
                    background-color: #dedede;
                }
                .page-box {
                    //height: 45px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
            /*width: calc(68% - 20px);*/
        }
        .energy-data-query-right {
            padding-left: 2rem;
            width: 19%;
            .right-item {
                align-items: center;
                .div-hr {
                    height: 1px;
                    background-color: #dedede;
                }
                .info{
                    font-size: 0.9rem;
                    word-wrap: break-word;
                }
                background-color: white;
            }
        }

    }
</style>
